export default __webpack_public_path__ + "static/media/Shadowed Valleys-20.1b614049.jpg";